module.exports = __webpack_public_path__ + "static/media/unlink.3d99231a.png";